<section class="background-color-nearwhite">
    <div class="container" *ngIf="!(itemsNumber$ | async)">
        <h1 [innerHTML]="'checkoutPage.titleEmpty' | translate"></h1>
        <p class="large" [innerHTML]="'checkoutPage.suggestions' | translate"></p>
        <p class="large">
            <span [innerHTML]="'checkoutPage.try' | translate"></span>
        </p>
        <a da-link class="button secondary" [routerLink]="coursesLink" [innerHTML]="'checkoutPage.linkText' | translate"></a>
    </div>
    <div class="container" *ngIf="itemsNumber$ | async">
        <h1 class="title" [innerHTML]="'checkoutPage.title' | translate"></h1>
        <p class="large" [innerHTML]="'checkoutPage.intro' | translate"></p>
        <da-checkout-list (nextStep)="next($event)"></da-checkout-list>
    </div>
</section>
